import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type VulnerabilityAssessmentInfo = {
  id: number | null;
};

type VulnerabilityAssessmentStateType = {
  selectedEntityVulnerabilityAssessmentInfo: VulnerabilityAssessmentInfo;
};

const INITAL_VULNERABILITY_ASSESSMENT_STATE: VulnerabilityAssessmentStateType =
  {
    selectedEntityVulnerabilityAssessmentInfo: { id: null },
  };

const VulnerabilityAssessmentSlice = createSlice({
  name: 'vulnerability-assessment',
  initialState: INITAL_VULNERABILITY_ASSESSMENT_STATE,
  reducers: {
    setSelectedEntityVulnerabilityAssessmentInfo: (
      state,
      action: PayloadAction<VulnerabilityAssessmentInfo>
    ) => {
      state.selectedEntityVulnerabilityAssessmentInfo.id = action.payload.id;
    },
  },
});

export const { setSelectedEntityVulnerabilityAssessmentInfo } =
  VulnerabilityAssessmentSlice.actions;

export default VulnerabilityAssessmentSlice.reducer;
